export class ForgotPasswordRequestModel {
    type: string;
    id: string;
}


// WEBPACK FOOTER //
// ./src/app/_models/login/ForgotPasswordRequestModel.ts